import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';

import { debounceTime, Observable, Subject, Subscription } from 'rxjs';

@Injectable()
export class FrontendKeyboardService {
  keyboardVisible$: Observable<boolean>;
  currentKeyboardHeight = 0;
  isKeyboardVisible = false;

  private readonly scrollIntoView$ = new Subject<Element | null>();
  private readonly keyboardVisibleSource$ = new Subject<boolean>();
  private readonly subscription = new Subscription();

  constructor(private readonly platform: Platform) {
    this.keyboardVisible$ = this.keyboardVisibleSource$.asObservable();
  }

  init(): void {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    const scrollSub = this.scrollIntoView$
      .pipe(debounceTime(300))
      .subscribe((el) => {
        const tagsToCenter = ['TEXTAREA'];
        if (el && (
          tagsToCenter.includes(el.tagName) ||
          (el.tagName === 'INPUT' && !el.classList.contains('native-input'))
        )) {
          el.scrollIntoView({ block: 'center' });
        }
      });
    this.subscription.add(scrollSub);

    const showSub = this.platform.keyboardDidShow
      .subscribe(({ keyboardHeight }) => {
        this.currentKeyboardHeight = keyboardHeight;
        this.keyboardVisibleSource$.next(true);
        this.scrollIntoView$.next(document.activeElement);
      });
    this.subscription.add(showSub);

    const hideSub = this.platform.keyboardDidHide
      .subscribe(() => {
        this.currentKeyboardHeight = 0;
        this.keyboardVisibleSource$.next(false);
      });
    this.subscription.add(hideSub);
  }
}
